import Button from "@mui/material/Button";
import Modal from "components/modal/modal";
import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./delete-release-modal.module.scss";
import { ReleaseNoteType } from "components/release";

interface Props {
  data: ReleaseNoteType;
  onConfirm: () => void;
  onClose: () => void;
}

const DeleteReleaseModal: React.FC<Props> = ({ data, onConfirm, onClose }) => {
  const [t] = useTranslation();

  const confirmDeleteRelease = (): void => {
    onConfirm();
    onClose();
  };

  return (
    <Modal
      header={t("userSystem.deleteReleaseNote.title")}
      opened={!!data.id}
      onClose={onClose}
    >
      <div className={styles.info}>
        <div className={styles.text}>
          {`${t("userSystem.deleteReleaseNote.prefix")}${data.title}${t(
            "userSystem.deleteReleaseNote.suffix"
          )}`}
        </div>

        <div className={styles.button}>
          <Button
            variant="text"
            color="success"
            onClick={onClose}
            style={{ outline: "none" }}
          >
            {t("buttons.cancel")}
          </Button>
          &nbsp;&nbsp;
          <Button
            variant="contained"
            color="error"
            onClick={confirmDeleteRelease}
          >
            {t("buttons.delete")}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteReleaseModal;
